import { ConsultaSolicitudDeServicioProcessRequest, ConsultaSolicitudDeServicio_Parametros, ConsultaSolicitudDeServicio_Respuesta, builtConsultaSolicitudDeServicioProcessRequest, builtConsultaSolicitudDeServicio_Entrada } from "../Commons/Services/ConsultaSolicitudDeServicioRest";
import { Atributo, ConsultarLDAP_Parametros, ConsultarLDAP_Respuesta, builtAtributoConsultarLDAP_entrada, builtConsultarLDAP_entrada } from "../Commons/Services/ConsultarLDAP";
import { ConsultaWS } from "../Commons/ServiciosBase";
import { ActivacionBlueToGoRest_Parametros, ActivacionBlueToGoRest_Respuesta, InputActivacion, builtActivacionBlueToGoRestInput, builtInputActivacion } from "../Commons/Services/ActivacionBlueToGoRest";

export async function consultaLDAP( ) {

    const atributo: Atributo[]= [builtAtributoConsultarLDAP_entrada("","")];
    const par = builtConsultarLDAP_entrada("","","","","","","",sessionStorage.getItem("cuenta")!,"","",sessionStorage.getItem("rowId")!,"",
                                                "","","","","","","","","","","",atributo,"","",sessionStorage.getItem("cuenta")+"-01","","",
                                                "","6","","");
      let parametros = ConsultarLDAP_Parametros(par);
      let ConsultarLDAPRespuesta: ConsultarLDAP_Respuesta =   await ConsultaWS(parametros);

    return ConsultarLDAPRespuesta;
}


export async function consultaSolicitudServicio( ) {

  const consultaSolicitudDeServicioProcessRequest: ConsultaSolicitudDeServicioProcessRequest = builtConsultaSolicitudDeServicioProcessRequest(
    `${sessionStorage.getItem("rowId")}`,
    "Web",
    "Canales a la Carta"
  );
  const par = builtConsultaSolicitudDeServicio_Entrada(consultaSolicitudDeServicioProcessRequest);
  let parametros = ConsultaSolicitudDeServicio_Parametros(par);
  let consultaSolicitudDeServicio_Respuesta: ConsultaSolicitudDeServicio_Respuesta =   await ConsultaWS(parametros);

  return consultaSolicitudDeServicio_Respuesta;
}


export async function activacionBlueToGo( ) {

  const input: InputActivacion= builtInputActivacion(sessionStorage.getItem("cuenta")!,sessionStorage.getItem("Paquete")!,"YES","NO","1","0","",
                                                        sessionStorage.getItem("idSesion")!,"BTG","true","","","Web");
  const par = builtActivacionBlueToGoRestInput(input);
  let parametros = ActivacionBlueToGoRest_Parametros(par);
  let activacionBlueToGoRest_Respuesta: ActivacionBlueToGoRest_Respuesta =   await ConsultaWS(parametros);

  return activacionBlueToGoRest_Respuesta;
}
